import { withNamespaces } from 'react-i18next';

import { CyberSecurityStatuses } from '../../constants';

const FindingDetail = ({
    category,
    check,
    onClose,
    t,
}) => {
    if (!check && category?.status === 'passed') {
        return (
            <div className="cyber-success-panel">
                <div className="avatar-lg mx-auto mb-3">
                    <span className="avatar-title rounded-circle bg-soft-success text-success">
                        <i className={`${category.icon} font-size-24`} />
                    </span>
                </div>
                <div className="text-success mb-2">
                    <i className="ri-checkbox-circle-fill" />
                </div>
                <h5>{t(category.successTitle || 'All checks passed')}</h5>
                <p className="text-muted">
                    {t(category.successDescription || category.description)}
                </p>
                {category.meaning?.length > 0 && (
                    <div className="text-start mt-4">
                        <div className="fw-medium mb-2">{t('What this means')}</div>
                        <ul className="text-muted ps-3 mb-0">
                            {category.meaning.map((item) => (
                                <li key={item}>{t(item)}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    }

    if (!check) return null;

    const status = CyberSecurityStatuses[check.status];

    return (
        <div>
            <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
                <div>
                    <h5 className="mb-1">{t(check.title)}</h5>
                    <span className={status.className}>
                        <i className={`${status.icon} align-middle me-1`} />
                        {t(status.title)}
                    </span>
                </div>
                {onClose && (
                    <button
                        aria-label={t('Close')}
                        className="btn btn-link p-0 text-muted"
                        onClick={onClose}
                        type="button"
                    >
                        <i className="ri-close-line font-size-18" />
                    </button>
                )}
            </div>

            <div className={`cyber-finding-banner cyber-finding-${status.color} mb-3`}>
                <i className={`${status.icon} ${status.className}`} />
                <span>{t(check.headline || check.summary)}</span>
            </div>

            {check.findings?.length > 0 && (
                <div className="mb-4">
                    <h6 className="mb-3">{t('What we found')}</h6>
                    {check.findings.map((item) => (
                        <div className="cyber-found-row" key={item.label}>
                            <span>{t(item.label)}</span>
                            <span className={item.tone ? `text-${item.tone}` : 'fw-medium'}>
                                {t(item.value)}
                                <i className="ri-arrow-right-s-line text-muted ms-1" />
                            </span>
                        </div>
                    ))}
                </div>
            )}

            {(check.whyItMatters || check.meaning?.length) && (
                <div className={`cyber-note ${status.color === 'warning' ? 'is-warning' : ''} mb-3`}>
                    <i className={`${status.color === 'warning' ? 'ri-error-warning-line text-warning' : 'ri-information-line text-primary'}`} />
                    <div>
                        <div className="fw-medium mb-1">{t('Why this matters')}</div>
                        <p className="text-muted mb-0">{t(check.whyItMatters || category?.whyItMatters)}</p>
                    </div>
                </div>
            )}

            {check.evidence && (
                <button className="cyber-evidence" type="button">
                    <i className="ri-database-2-line" />
                    <span>
                        <span className="d-block fw-medium">{t('Technical evidence')}</span>
                        <span className="text-muted font-size-12">{t(check.evidence)}</span>
                    </span>
                    <i className="ri-arrow-right-s-line text-muted" />
                </button>
            )}
        </div>
    );
};

export default withNamespaces()(FindingDetail);
